import React from 'react';
import cx from 'classnames';

import { RegistrationQuizStep, SelectNumberOption, SelectOption } from 'types';

import css from './multiSelect.module.sass';

type Props = {
  options: SelectOption[] | SelectNumberOption[];
  currentStep: RegistrationQuizStep;
  selectedAnswers: number[];
  handleChange: (name: string, value: number) => void;
};

export const MultiSelect: React.FC<Props> = React.memo(
  ({ options, currentStep, selectedAnswers, handleChange }) => {
    return (
      <div className={css.root}>
        {options.map((option) => (
          <div
            key={option.value}
            className={cx(css.option, {
              [css.selected]: selectedAnswers.includes(+option.value),
            })}
            onClick={() => handleChange(currentStep.name, +option.value)}
          >
            <p className={css.text}>{option.label}</p>
          </div>
        ))}
      </div>
    );
  }
);
